import { render } from "./FooterSide.vue?vue&type=template&id=460bb276"
import script from "./FooterSide.vue?vue&type=script&lang=js"
export * from "./FooterSide.vue?vue&type=script&lang=js"

import "./FooterSide.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__